import { useMutation } from '@tanstack/react-query';


const useDownloadCSV = (downloadFn, fileName) => {
  const onSuccessDownloadCSV = (response) => {
    const blob = new Blob([response.data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', fileName);

    document.body.appendChild(link);

    link.click();
    link.parentNode.removeChild(link);
  };


  const { mutate, isLoading } = useMutation(downloadFn, {
    onSuccess: onSuccessDownloadCSV,
    onError: (error) => {
      console.error('Error downloading the file:', error);
    },
  });

  const DownloadButton = () => (
    <button className="btn btn-outline-primary right btn-sm" onClick={() => mutate()} disabled={isLoading}>
      {isLoading ? 'Downloading...' : 'Download CSV'}
    </button>
  );

  return DownloadButton;
};

export default useDownloadCSV;